import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";

//Dev

// const firebaseConfig = {
//   apiKey: "AIzaSyAADbZJQ1faQ_DpAwtZcCD1Q5QGMdNfAWU",
//   authDomain: "eu-we-re-prime-dev.firebaseapp.com",
//   databaseURL:
//     "https://eu-we-re-prime-dev-riders-portal.europe-west1.firebasedatabase.app/",
//   projectId: "eu-we-re-prime-dev",
//   storageBucket: "eu-we-re-prime-dev.appspot.com",
//   messagingSenderId: "678404654400",
//   appId: "1:678404654400:web:63986fad5dacb52c6926a5",
//   measurementId: "G-XNYY2RDSW4"
// };

//Stage

// const firebaseConfig = {
//   apiKey: "AIzaSyAzIJam7pE_-1SAfn22yN2t2n8MnWZ6m-s",
//   authDomain: "eu-we-re-prime-uat.firebaseapp.com",
//   databaseURL: "https://eu-we-re-prime-uat-riders-portal.europe-west1.firebasedatabase.app/",
//   projectId: "eu-we-re-prime-uat",
//   storageBucket: "eu-we-re-prime-uat.appspot.com",
//   messagingSenderId: "231589682641",
//   appId: "1:231589682641:web:22af7a4797349a2fdbd4f0",
//   measurementId: "G-1N9Q5VQW6T",
// };

//Prod

const firebaseConfig = {
  apiKey: "AIzaSyDWkEARLQC5cM14VaG2t6doJeB_uVXAeYk",
  authDomain: "eu-we-re-prime-prod01.firebaseapp.com",
  databaseURL: "https://eu-we-re-prime-prod-riders-portal.europe-west1.firebasedatabase.app/",
  projectId: "eu-we-re-prime-prod01",
  storageBucket: "eu-we-re-prime-prod01.appspot.com",
  messagingSenderId: "901165690560",
  appId: "1:901165690560:web:7c17636610547eb57a8725",
  measurementId: "G-EJFX457GJX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);

// Compatibility wrapper to match old API
const firebase = {
  auth: () => auth,
  database: () => database,
  // Add helper methods for compatibility
  signInAnonymously: () => signInAnonymously(auth),
  databaseRef: (path = '') => ref(database, path),
  onValue: onValue
};

export default firebase;